<div class="register-with-referralid-page">
  <div class="logo-wrap text-center">
    <img src="assets/images/logo-dark.svg" />
  </div>
  <div class="register-with-referral-wrap d-flex rounded-top">
    <div class="auth-content col-12 col-md-6 p-5 pt-0">
      <h2 class="text-header text-bold text-center text-dark my-4 d-none d-md-block" i18n="@@front.register.title">Sign
        Up</h2>
      <div class="banner-text mx-4 text-xl text-center mb-4 d-block d-md-none">
        <ng-contaner *ngIf="referrerName; then referralDescription; else referralError">></ng-contaner>
      </div>
      <p class="text-center mb-4" i18n="@@front.registerWithReferral.subTitle">Refferal code: <strong>{{referralId}}</strong></p>
      <auth-register class="auth-form" [referralId]="referralId"></auth-register>
    </div>
    <div class="banner-content d-none d-md-flex col-lg-6">
      <div class="banner-text mt-5 mx-4 text-xxxl text-center">
        <ng-contaner *ngIf="referrerName; then referralDescription; else referralError">></ng-contaner>
      </div>
      <div class="banner-wrap">
        <img class="w-100" srcset="
          assets/images/affiliate-program/affiliate-program-hero-img-1x.webp,
          assets/images/affiliate-program/affiliate-program-hero-img-1.5x.webp 1.5x,
          assets/images/affiliate-program/affiliate-program-hero-img-2x.webp   2x
        " src="assets/images/affiliate-program/affiliate-program-hero-img-1x.webp" alt="Affiliate Program Hero Image" />
      </div>
    </div>
  </div>

  <affiliate-steps color="#E9ECEF" backgroundColor="#F4F4F4" [isExperimentReferral]="isExperimentReferral"></affiliate-steps>

  <section class="d-flex gap-1 pt-3 pb-5 justify-content-between justify-content-md-center">
    <a routerLink="/page/terms-of-service" target="_blank" class="btn btn-link"
      i18n="@@front.registerWithReferral.mainAction.termsAndCondition">Terms and Conditions</a>
    <a routerLink="/page/invite-earn-program-guidelines" target="_blank" class="btn btn-link"
      i18n="@@front.registerWithReferral.mainAction.learnMore">Learn More</a>
  </section>
</div>

<ng-template #referralDescription>
  <span i18n="@@front.registerWithReferral.referrerDescription">You have been invited by {{referrerName}}. </span>
  <div class="p-2" *ngIf="promotion?.promotionEnabled"></div>
  <span *ngIf="!promotion?.promotionEnabled" i18n="@@front.registerWithReferral.getStarted">Get started on BitOasis to earn rewards together.</span>
  <ng-container *ngIf="promotion?.promotionEnabled">
    <p class="text-lg text-center" i18n="@@front.register.verifyAndEarnWithRefferal.subtitle">Get
      {{promotion?.reward?.currency}} {{promotion?.reward?.amount}} reward when you sign up and verify, with up to
      AED/SAR 500 referral bonus</p>
  </ng-container>
</ng-template>

<ng-template #referralError>
  <span i18n="@@front.registerWithReferral.error">Oops...You’re code is not valid. Please try again.</span>
</ng-template>
